import { render, staticRenderFns } from "./oceanengine.vue?vue&type=template&id=bf022172&scoped=true"
import script from "./oceanengine.vue?vue&type=script&lang=js"
export * from "./oceanengine.vue?vue&type=script&lang=js"
import style0 from "./oceanengine.vue?vue&type=style&index=0&id=bf022172&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf022172",
  null
  
)

export default component.exports